import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getLobDefinition, getCoverableDefinition } from '../util/CoverablesUtil';

export default class CoverablesService {
    static callMethod(lineName, coverableName, methodName, params, additionalHeaders) {
        const lobDefinition = getLobDefinition(lineName);
        const coverableDefinition = getCoverableDefinition(lineName, coverableName);
        const urlToProxy = lobDefinition.handler;
        const method = coverableDefinition.methods[methodName];
        const serviceUrl = getProxiedServiceUrl(urlToProxy);
        return JsonRPCService.send(serviceUrl, method, params, additionalHeaders);
    }
}
